"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var prop_types_1 = __importDefault(require("prop-types"));
var rc_tooltip_1 = __importDefault(require("rc-tooltip"));
var react_1 = __importDefault(require("react"));
var TooltipComponent = (function (_super) {
    __extends(TooltipComponent, _super);
    function TooltipComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TooltipComponent.prototype.render = function () {
        var _a = this.props, trigger = _a.trigger, overlay = _a.overlay, placement = _a.placement, _b = _a.overlayStyle, overlayStyle = _b === void 0 ? {} : _b, children = _a.children, others = __rest(_a, ["trigger", "overlay", "placement", "overlayStyle", "children"]);
        return (react_1.default.createElement(rc_tooltip_1.default, __assign({ placement: placement, trigger: trigger, overlay: overlay, overlayStyle: __assign({ maxWidth: 240 }, overlayStyle) }, others), children));
    };
    return TooltipComponent;
}(react_1.default.Component));
TooltipComponent.propTypes = {
    placement: prop_types_1.default.string.isRequired,
    trigger: prop_types_1.default.array.isRequired,
    overlayStyle: prop_types_1.default.object,
    overlay: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.node,
    ]).isRequired,
    children: prop_types_1.default.node.isRequired,
};
TooltipComponent.defaultProps = {
    placement: 'top',
    trigger: ['hover'],
};
exports.default = TooltipComponent;
